export const BLACK_ROUTE_PATH = [
  "/main",
  "/main/home",
  "/main/cityFacts/all",
  "/",
  // "/main/park/parkset/geomagnetic-historical-detail",
  "/main/coupon/update-platform-coupon",
  "/finance",
  "/main/finance/financeReport",
  "/main/report",
  "/main/equipment/directive",
  "/itil",
  "/main/user",
  "/main/wechatmini",
  "/member",
  "/monitoring",
  "/main/base",
  "/main/guidance-screen-system",
  "/main/inspector",
  "/main/park",
  "/main/record",
  "/main/payConfigure",
  "/main/dataAnalysis",
  "/main/park",
  "/main/vehicleManagement",
  "/operation",
  "/main/arrears-recovery",
  "/main/coupon",

  "/main/discount",
  "/main/merchant",
  "/sale",

  "/main/active-configuration",
  "/main/log",
  "/system",


  '/main/vehicleManagement/monthlyCar/renewal',

  '/main/equipment/guidance-display-screen/log'
 
];
